import { __assign, __rest } from "tslib";
import React from 'react';
import { FacebookIcon, PinterestIcon, RedditIcon, TumblrIcon, EmailIcon, TwitterIcon, } from 'react-share';
export var ShareIcon = function (_a) {
    var type = _a.type, props = __rest(_a, ["type"]);
    switch (type) {
        case 'facebook':
            return React.createElement(FacebookIcon, __assign({}, props));
        case 'twitter':
            return React.createElement(TwitterIcon, __assign({}, props));
        case 'pinterest':
            return React.createElement(PinterestIcon, __assign({}, props));
        case 'reddit':
            return React.createElement(RedditIcon, __assign({}, props));
        case 'tumblr':
            return React.createElement(TumblrIcon, __assign({}, props));
        case 'email':
            return React.createElement(EmailIcon, __assign({}, props));
        default:
            return null;
    }
};
ShareIcon.displayName = 'ShareIcon';
export default ShareIcon;
//# sourceMappingURL=ShareIcon.js.map